/**
 * assets/pdp-v4.js
 * Product Template v4 — simplified interactivity.
 */
(function () {
  'use strict';

  function formatMoney(cents, moneyFormat) {
    var amount = (cents / 100).toFixed(2);
    if (moneyFormat) return moneyFormat.replace('{{amount}}', amount).replace('{{amount_no_decimals}}', Math.round(cents / 100));
    return '\u00A3' + amount;
  }

  function initPdpV4(infoEl) {
    var moneyFormat    = infoEl.dataset.moneyFormat || null;
    var currentType    = infoEl.dataset.initialType || 'onetime';
    var selectedVariantId      = null;
    var selectedQuantity       = 1;
    var selectedDisplayQuantity = 1;
    var selectedPrice          = 0;
    var selectedAvailable      = true;
    var selectedSellingPlan    = null;

    // ── Read selected qty button ────────────────────────────────────────────
    function readActiveBtn() {
      var btn = infoEl.querySelector('.pdp-v4__qty-btn--active');
      if (!btn) btn = infoEl.querySelector('.pdp-v4__qty-btn');
      if (btn) {
        selectedVariantId       = parseInt(btn.dataset.variantId, 10) || null;
        selectedQuantity        = parseInt(btn.dataset.quantity, 10) || 1;
        selectedDisplayQuantity = parseInt(btn.dataset.displayQuantity, 10) || 1;
        selectedPrice           = parseInt(btn.dataset.price, 10) || 0;
        selectedAvailable       = btn.dataset.available !== 'false';
        selectedSellingPlan     = btn.dataset.sellingPlan || null;
      }
    }
    readActiveBtn();

    // ── Purchase type radio ─────────────────────────────────────────────────
    var typeBtns = infoEl.querySelectorAll('.pdp-v4__radio-btn');

    function updateHeadingPrice() {
      var priceEl = infoEl.querySelector('.pdp-v4__heading-price');
      if (!priceEl) return;
      var otpPrice        = priceEl.dataset.otpPrice;
      var snsPrice        = priceEl.dataset.snsPrice;
      var info            = priceEl.dataset.priceInfo;
      var servingPrice    = priceEl.dataset.servingPrice || '';
      var snsServingPrice = priceEl.dataset.snsServingPrice || '';
      if (!otpPrice) return;
      var servingSuffix    = servingPrice    ? ' \u00B7 ' + servingPrice    + '/serving' : '';
      var snsServingSuffix = snsServingPrice ? ' \u00B7 <span class="pdp-v4__heading-rrp">' + servingPrice + '</span> ' + snsServingPrice + '/serving' : '';
      if (currentType === 'subscription' && snsPrice) {
        priceEl.innerHTML = 'From <span class="pdp-v4__heading-rrp">' + otpPrice + '</span> ' + snsPrice + info + snsServingSuffix;
      } else {
        priceEl.innerHTML = otpPrice + info + servingSuffix;
      }
    }

    function setType(type) {
      currentType = type;
      typeBtns.forEach(function (btn) {
        btn.classList.toggle('pdp-v4__radio-btn--active', btn.dataset.type === type);
      });
      var benefits     = infoEl.querySelector('.pdp-v4__sns-benefits');
      var purchaseType = infoEl.querySelector('.pdp-v4__purchase-type');
      var isSub = type === 'subscription';
      if (benefits)     benefits.classList.toggle('hidden', !isSub);
      if (purchaseType) purchaseType.classList.toggle('pdp-v4__purchase-type--open', isSub);
      updateHeadingPrice();
      updateCta();
    }

    typeBtns.forEach(function (btn) {
      btn.addEventListener('click', function () { setType(btn.dataset.type); });
    });

    // ── Quantity variant buttons ────────────────────────────────────────────
    var qtyBtns = infoEl.querySelectorAll('.pdp-v4__qty-btn');

    qtyBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        qtyBtns.forEach(function (b) { b.classList.remove('pdp-v4__qty-btn--active'); });
        btn.classList.add('pdp-v4__qty-btn--active');
        selectedVariantId       = parseInt(btn.dataset.variantId, 10) || null;
        selectedQuantity        = parseInt(btn.dataset.quantity, 10) || 1;
        selectedDisplayQuantity = parseInt(btn.dataset.displayQuantity, 10) || 1;
        selectedPrice           = parseInt(btn.dataset.price, 10) || 0;
        selectedAvailable       = btn.dataset.available !== 'false';
        selectedSellingPlan     = btn.dataset.sellingPlan || null;

        // No URL update needed — quantity multiplier doesn't change the variant

        updateCta();
      });
    });

    // ── CTA price / label ───────────────────────────────────────────────────
    var atcBtn      = infoEl.querySelector('.pdp-v4__atc');
    var atcPriceEl  = infoEl.querySelector('.pdp-v4__atc-price');
    var atcPipeEl   = infoEl.querySelector('.pdp-v4__atc-pipe');
    var atcLabelEl  = infoEl.querySelector('.pdp-v4__atc-label');

    function updateCta() {
      if (!selectedAvailable) {
        if (atcPriceEl) { atcPriceEl.textContent = ''; atcPriceEl.style.display = 'none'; }
        if (atcPipeEl)  atcPipeEl.style.display = 'none';
        if (atcLabelEl) atcLabelEl.textContent = 'Out of Stock';
        if (atcBtn)     { atcBtn.disabled = true; atcBtn.style.opacity = '0.5'; }
        return;
      }

      if (atcBtn)    { atcBtn.disabled = false; atcBtn.style.opacity = '1'; }
      if (atcPipeEl) atcPipeEl.style.display = '';

      var label = currentType === 'subscription' ? 'ADD TO SUBSCRIPTION' : 'ADD TO CART';
      if (atcLabelEl) atcLabelEl.textContent = label;

      if (atcPriceEl && selectedPrice > 0) {
        atcPriceEl.textContent = formatMoney(selectedPrice, moneyFormat);
        atcPriceEl.style.display = '';
      }
    }

    // ── Add to cart ─────────────────────────────────────────────────────────
    if (atcBtn) {
      atcBtn.addEventListener('click', function () {
        if (!selectedVariantId || !selectedAvailable) return;

        // Subscription → redirect to bundle builder if configured
        var bundleUrl = infoEl.dataset.bundleUrl;
        if (currentType === 'subscription' && bundleUrl) {
          window.location.href = bundleUrl + (selectedQuantity > 1 ? ':' + selectedQuantity : '');
          return;
        }

        atcBtn.disabled = true;
        var origLabel = atcLabelEl ? atcLabelEl.textContent : '';
        if (atcLabelEl) atcLabelEl.textContent = 'Adding\u2026';

        var item = { id: selectedVariantId, quantity: selectedQuantity };
        if (currentType === 'subscription' && selectedSellingPlan) {
          item.selling_plan = parseInt(selectedSellingPlan, 10);
        }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items: [item] })
        })
          .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
          .then(function (res) {
            if (!res.ok) {
              var msg = (res.data && res.data.description) || 'Something went wrong \u2014 please try again';
              if (atcLabelEl) atcLabelEl.textContent = msg;
              atcBtn.disabled = false;
              setTimeout(function () { if (atcLabelEl) atcLabelEl.textContent = origLabel; }, 4000);
              return;
            }
            window.location.href = '/cart';
          })
          .catch(function () {
            if (atcLabelEl) atcLabelEl.textContent = 'Something went wrong \u2014 please try again';
            atcBtn.disabled = false;
            setTimeout(function () { if (atcLabelEl) atcLabelEl.textContent = origLabel; }, 4000);
          });
      });
    }

    // ── Gallery ─────────────────────────────────────────────────────────────
    var section = infoEl.closest('.product-template');
    setTimeout(function () { initGallery(section); }, 0);

    // ── Init ─────────────────────────────────────────────────────────────────
    updateCta();
  }

  // ── Gallery (shared with v3 pattern) ──────────────────────────────────────
  function initGallery(section) {
    if (!section) return;
    var mainEl   = section.querySelector('.pdp-gallery-swiper--desktop');
    var thumbsEl = section.querySelector('.pdp-gallery-swiper--thumbs');
    var prevBtn  = section.querySelector('.pdp-swiper__prev');
    var nextBtn  = section.querySelector('.pdp-swiper__next');

    if (mainEl && mainEl.swiper) return;
    if (mainEl && mainEl.dataset.v4GalleryInit) return;
    if (mainEl) mainEl.dataset.v4GalleryInit = '1';

    var slides  = mainEl   ? Array.from(mainEl.querySelectorAll('.swiper-slide'))   : [];
    var thumbs  = thumbsEl ? Array.from(thumbsEl.querySelectorAll('.swiper-slide')) : [];
    var current = 0;

    if (slides.length === 0) return;

    function goTo(index) {
      if (index < 0) index = slides.length - 1;
      if (index >= slides.length) index = 0;
      current = index;
      mainEl.scrollLeft = 0;
      var wrapper = mainEl.querySelector('.swiper-wrapper');
      if (wrapper) wrapper.style.transform = 'translateX(-' + (current * mainEl.offsetWidth) + 'px)';
      thumbs.forEach(function (t, i) { t.style.opacity = i === current ? '1' : '0.5'; });
    }

    var wrapper = mainEl.querySelector('.swiper-wrapper');
    if (wrapper) {
      wrapper.style.display    = 'flex';
      wrapper.style.transition = 'transform 0.3s ease';
      wrapper.style.willChange = 'transform';
      mainEl.style.touchAction = 'pan-y';
      mainEl.style.overflowX   = 'hidden';
      slides.forEach(function (s) {
        s.style.width    = mainEl.offsetWidth + 'px';
        s.style.minWidth = mainEl.offsetWidth + 'px';
        s.style.flexShrink = '0';
      });
      window.addEventListener('resize', function () {
        var w = mainEl.offsetWidth;
        slides.forEach(function (s) { s.style.width = w + 'px'; s.style.minWidth = w + 'px'; });
        goTo(current);
      });
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); });
    thumbs.forEach(function (t, i) { t.style.cursor = 'pointer'; t.addEventListener('click', function () { goTo(i); }); });

    var touchStartX = null;
    mainEl.addEventListener('touchstart', function (e) { touchStartX = e.touches[0].clientX; }, { passive: true });
    mainEl.addEventListener('touchend', function (e) {
      if (touchStartX === null) return;
      var diff = touchStartX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 40) goTo(current + (diff > 0 ? 1 : -1));
      touchStartX = null;
    }, { passive: true });

    goTo(0);
  }

  // ── Reviews modal (document-level capture) ─────────────────────────────────
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('.reviews-modal-trigger');
    if (!trigger) return;
    // Only handle if we're inside a v4 info panel
    if (!trigger.closest('.product-template-v4__info') && !document.querySelector('.product-template-v4__info')) return;
    e.stopPropagation();
    e.preventDefault();

    var overlay = document.querySelector('.pdp-v4__reviews-overlay');
    if (!overlay) return;

    var body = overlay.querySelector('.pdp-v4__reviews-body');
    overlay.classList.remove('hidden');
    document.body.style.overflow = 'hidden';
    if (!body || body.dataset.initialized) return;
    body.dataset.initialized = '1';

    var sku = trigger.dataset.sku || '';

    function initWidget() {
      var el = document.createElement('div');
      el.id = 'pdp-v4-reviews-' + Date.now();
      body.appendChild(el);
      new ReviewsWidget('#' + el.id, {
        store: 'take-stock',
        widget: 'polaris',
        options: {
          types: 'product_review',
          lang: 'en',
          per_page: 10,
          product_review: { sku: sku },
          header: { enable_summary: true, enable_ratings: true, enable_attributes: false, enable_image_gallery: false, enable_percent_recommended: false, enable_write_review: false, enable_ask_question: false, enable_sub_header: true, rating_decimal_places: 2, use_write_review_button: false },
          filtering: { enable: true, enable_text_search: false, enable_sorting: true, enable_overall_rating_filter: true, enable_ratings_filters: false },
          reviews: { default_sort: 'highest_rating', enable_avatar: false, enable_reviewer_name: true, enable_reviewer_address: false, enable_verified_badge: true, enable_images: true, enable_share: false, enable_helpful_vote: true, enable_date: true }
        },
        styles: {
          '--base-font-size': '16px', '--common-star-color': '#FF9600', '--common-star-disabled-color': 'rgba(0,0,0,0.25)',
          '--medium-star-size': '22px', '--small-star-size': '19px', '--heading-text-color': '#2c2c2c',
          '--heading-text-font-weight': '700', '--heading-text-font-family': 'inherit', '--body-text-color': '#2c2c2c',
          '--body-text-font-family': 'inherit', '--badge-text-color': '#2c2c2c', '--badge-icon-color': '#2c2c2c',
          '--pagination-tab-text-color': '#2c2c2c', '--pagination-tab-active-text-color': '#2c2c2c',
          '--pagination-tab-active-border-color': '#2c2c2c', '--common-border-color': '#DDCEB8',
          '--inputfield-text-font-family': 'inherit', '--inputfield-border-color': 'rgba(0,0,0,0.2)'
        }
      });
    }

    if (window.ReviewsWidget) { initWidget(); return; }
    var existing = document.querySelector('script[src*="polaris/build.js"]');
    if (existing) { var poll = setInterval(function () { if (window.ReviewsWidget) { clearInterval(poll); initWidget(); } }, 50); return; }
    var s = document.createElement('script');
    s.src = 'https://widget.reviews.co.uk/polaris/build.js';
    s.onload = initWidget;
    document.head.appendChild(s);
  }, true);

  // ── Reviews modal close ────────────────────────────────────────────────────
  document.addEventListener('click', function (e) {
    var overlay = document.querySelector('.pdp-v4__reviews-overlay');
    if (!overlay) return;
    var closeBtn = e.target.closest('.pdp-v4__reviews-close');
    if (closeBtn || e.target === overlay) {
      overlay.classList.add('hidden');
      document.body.style.overflow = '';
    }
  });

  // ── Accordions (delegated) ─────────────────────────────────────────────────
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('.pdp-v4__accordion-trigger');
    if (!trigger) return;
    var body = trigger.nextElementSibling;
    if (!body) return;
    var isOpen = !body.classList.contains('hidden');
    body.classList.toggle('hidden', isOpen);
    trigger.setAttribute('aria-expanded', String(!isOpen));
    var arrow = trigger.querySelector('.pdp-v4__accordion-arrow');
    if (arrow) arrow.style.transform = isOpen ? '' : 'rotate(180deg)';
  });

  // ── Escape key ────────────────────────────────────────────────────────────
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var overlay = document.querySelector('.pdp-v4__reviews-overlay');
    if (overlay && !overlay.classList.contains('hidden')) {
      overlay.classList.add('hidden');
      document.body.style.overflow = '';
    }
  });

  // ── Boot ──────────────────────────────────────────────────────────────────
  function init() {
    document.querySelectorAll('.product-template-v4__info').forEach(initPdpV4);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
